import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import NOVU from "../novu";

export const NotificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: NOVU.NOVU_BACKEND_URL
  }),
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getFeeds: builder.query({
      query: () => {
        return {
          url: `/v1/feeds`,
          method: "GET"
        };
      }
    }),
    getLayouts: builder.query({
      query: () => {
        return {
          url: `/v1/layouts`,
          method: "GET"
        };
      }
    }),
    getUnseenCount: builder.query({
      query: ({ subscriberId }: { subscriberId: string }) => {
        return {
          url: `/v1/subscribers/${subscriberId}/notifications/unseen?limit=1000`,
          method: "GET"
        };
      }
    }),
    notificationAction: builder.query({
      query: ({ method, headers: hd, body, url }) => {
        const headers: any = {
          "x-muse-version": "v1",
          "x-muse-zone": "Asia/Kolkata",
          "x-muse-caller": "intermicroservice",
          "x-muse-org": "gl-india",
          "x-muse-request-id": "RQ1234567890"
        };
        Object.keys(hd).forEach((key: any) => {
          const newKey = key.replaceAll("_", "-");
          headers[newKey] = hd[key];
        });

        return {
          url,
          method,
          headers,
          body
        };
      }
    })
  })
});

export const {
  useLazyGetFeedsQuery,
  useGetFeedsQuery,
  useLazyGetLayoutsQuery,
  useGetUnseenCountQuery,
  useLazyGetUnseenCountQuery,
  useGetLayoutsQuery,
  useLazyNotificationActionQuery,
  useNotificationActionQuery
} = NotificationApi;
